import { render, staticRenderFns } from "./VariableScreen.vue?vue&type=template&id=dd7fc698&"
import script from "./VariableScreen.vue?vue&type=script&lang=ts&"
export * from "./VariableScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports